import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/useLanguage";
import { conversionCopy } from "@/lib/conversionCopy";

const Hero = () => {
  const { t, language } = useLanguage();
  const copy = conversionCopy[language];

  return (
    <section className="relative min-h-[480px] md:min-h-[600px] flex items-center">
      {/* Full-width background image */}
      <img
        src="https://images.pexels.com/photos/6329073/pexels-photo-6329073.jpeg?auto=compress&cs=tinysrgb&w=1200"
        alt={t("hero.imgAlt")}
        width="1200"
        height="800"
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Dark gradient overlay — stronger on mobile */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/90 via-primary/75 to-primary/50 md:from-primary/80 md:via-primary/60 md:to-primary/30" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20 text-center">
        <span className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-sm font-medium mb-6 md:mb-8 border border-white/20">
          {copy.badge}
        </span>

        <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-[56px] font-bold text-white leading-[1.15] tracking-tight mb-4 md:mb-5">
          {copy.headline}
        </h1>

        <p className="text-base md:text-xl text-white/80 leading-relaxed mb-6 md:mb-8 max-w-lg mx-auto">
          {copy.intro}
        </p>

        <div className="flex flex-col items-center gap-3 justify-center mb-6">
          <Link to="/get-quote" className="w-full sm:w-auto">
            <Button size="lg" className="w-full sm:w-auto rounded-xl px-8 py-4 text-lg font-semibold bg-white text-[#1B2A4A] hover:bg-white/90 shadow-lg">
              {copy.callback}
            </Button>
          </Link>
          <Button asChild variant="outline" className="min-h-12 bg-transparent text-primary-foreground border-primary-foreground/40 hover:bg-primary-foreground/10 hover:text-primary-foreground">
            <a href="https://wa.me/66821858187" target="_blank" rel="noopener noreferrer"><MessageCircle />WhatsApp</a>
          </Button>
        </div>


        
      </div>
    </section>
  );
};
export default Hero;
